import { render, staticRenderFns } from "./SensorDataDetails.vue?vue&type=template&id=0613c95c&scoped=true&"
import script from "./SensorDataDetails.vue?vue&type=script&lang=js&"
export * from "./SensorDataDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613c95c",
  null
  
)

export default component.exports